<template>
  <table class="table-hover reports-table time-off-balances-report-table table">
    <tbody class="grouping-header">
      <tr v-if="baseColCount">
        <th>
          {{ source.main }}
        </th>
        <th
          v-for="col in colCount"
          :key="col"
        ></th>
      </tr>
    </tbody>

    <tbody class="tbody">
      <tr
        v-for="(row, rowIndex) in source.rows"
        :key="`${row.record.id}-${rowIndex}`"
      >
        <td v-if="subShow">
          {{ row.record.sub }}
        </td>
        <td>{{ $filters.formatDuration(row.record.used, false, '-', false, true) }}</td>
        <td>{{ $filters.formatDuration(row.record.pending, false, '-', false, true) }}</td>
        <td>{{ $filters.formatDuration(row.record.balance, false, '-', false, true) }}</td>
        <td class="compact-list-cell long-text">
          <TimeOffBalancesReportManualAdjustments
            v-if="row.record.manual_adjustments"
            :manual-adjustments="row.record.manual_adjustments"
            :members="allMembers"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
// Section renderer for TimeOffBalancesReportTable's virtual list.
//
// vue3-virtual-scroll-list renders each section through `data-component` (it does
// NOT consume a `#item` slot). The parent passes the section as `source` and the
// table layout context via `extra-props`.
import TimeOffBalancesReportManualAdjustments from './TimeOffBalancesReportManualAdjustments.vue';

export default {
  name: 'TimeOffBalancesReportSection',
  components: { TimeOffBalancesReportManualAdjustments },
  props: {
    source: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    baseColCount: {
      type: Number,
      default: 0,
    },
    colCount: {
      type: Number,
      default: 0,
    },
    subShow: {
      type: Boolean,
      default: false,
    },
    allMembers: {
      type: Array,
      default: () => [],
    },
    // Absorbs the prop the virtual list passes to every row component so it
    // doesn't leak onto the DOM as a `scopedslots` attribute.
    scopedSlots: {
      type: Object,
      default: undefined,
    },
  },
};
</script>
